module.exports = "//a.spikex.com/sigma/frontend-ssr-web-user-center/_next/static/images/updatafile-4e1648700b4a53a5513e32ed1df6f109.png";